<app-modal-dialog 
[show]="showModal" 
size="auto" 
position="top"
(closed)="closedDetailCoa()"
#modal >
    <div class="modal-header" modal-header>
        <h1>Detalle COA</h1>
        <h1 style="left: 0" class="i-hover">
            <i class="fa fa-xmark" (click)="closeModal(modal)"></i>
        </h1>
    </div>
    <div class="modal-body" modal-body>
        <div class="row mb-4" *ngIf="currentCoa">
            <div class="col-md-6">
                <span class="font-bold">Fecha.
                    <span class="font-medium">
                        {{currentCoa.date | date: 'yyyy-MM-dd'}}
                    </span>
                </span>
            </div>
            <div class="col-md-6">
                <span class="font-bold">No.
                    <span class="font-medium">
                        {{currentCoa.number}}
                    </span>
                </span>
            </div>

            <div class="col-md-6">
                <span class="font-bold">Destinatario: 
                    <span class="font-medium">
                        {{currentCoa.recipientProviderData.name}}
                    </span>
                </span>
            </div>
            <div class="col-md-6">
                <span class="font-bold">Lote: 
                    <span class="font-medium">
                        {{currentCoa.batch}}
                    </span>
                </span>
            </div> 
            
            <div class="col-md-12">
                <span class="font-bold">Producto.
                    <span class="font-medium">
                        {{currentCoa.productData.name}}
                    </span>
                </span>
            </div>

            <div class="col-md-12 mb-4">
                <span class="font-bold">Código.
                    <span class="font-medium">
                        {{currentCoa.code}}
                    </span>
                </span>
            </div>

            <div class="row">
                <div class="col">
                    <div class="table-responsive table-bordered">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th class="ta">Parámetro</th>
                                    <th class="ta">Método</th>
                                    <th class="text-right">Valor</th>
                                    <th class="text-right">Comentario</th>
                                    <th class="td-center">Unidad/Item</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor=" let item of currentCoa.details; let i = index">
                                    <td class="ta font-bold">
                                        {{ item.parameterData.parameter }}
                                    </td>
                                    <td class="ta">
                                        {{ item.parameterData.method }}
                                    </td>
                                    <td class="text-right ">
                                        {{ item.value.toFixed(5) }}
                                    </td>
                                    <td class="text-right">
                                        {{ item.comment }}
                                    </td>
                                    <td class="td-center ">
                                        {{ item.parameterData.units }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="row mt-4">
	    </div>
        </div>
    </div>
</app-modal-dialog>